import { v4 as uuidv4 } from 'uuid';
import { CANVAS_JSON_PROPS } from '../../../config';
import { useEditorData } from '../providers/EditorProvider';
import { useFabricEditor } from './useFabricEditor';

export const useHandleHistory = () => {
  const { canvas } = useFabricEditor();
  const { setHistory, resetHistory } = useEditorData();

  const createSnapshot = (fabricCanvas?: fabric.Canvas) => {
    const targetCanvas = (fabricCanvas || canvas) as any;
    return targetCanvas?._objects.map((object: fabric.Object) => {
      // @ts-ignore
      if (!object.id) object.id = uuidv4();
      return {
        object,
        // Objects in a multi-selection keep coordinates relative to the
        // selection; the canvas serializer stores them in slide coordinates.
        data: targetCanvas._toObject(object, 'toJSON', CANVAS_JSON_PROPS),
      };
    });
  };

  const handleHistory = (fabricCanvas?: fabric.Canvas) => {
    setHistory(createSnapshot(fabricCanvas));
  };

  // Makes the current canvas the starting point: nothing to undo.
  const resetHistoryTo = (fabricCanvas: fabric.Canvas) => {
    resetHistory(createSnapshot(fabricCanvas));
  };

  return { handleHistory, resetHistoryTo };
};
